/* eslint-disable no-unused-vars */
import { authActions, selectAuth } from "Features/auth";
import { errorActions, selectError } from "Features/error";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Button, Input, Modal } from "Shared/ui";
import SelectLanguage from "Widgets/lang_select";

export const RecoverPasswordPage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const fetchAuth = useSelector(selectAuth.fetch);
	const errorPage = useSelector(selectError.page);
	const errorMessages = useSelector(selectError.message);
	const succes = useSelector(selectAuth.succes);
	const [isSent, setIsSent] = useState(false);
	const [email, setEmail] = useState("");
	const [renderErrors, setRenderErrors] = useState([]);
	const [isVisibleModal, setIsVisibleModal] = useState(false);

	useEffect(() => {
		return () => {
			dispatch(authActions.drop());
			dispatch(errorActions.drop());
		};
	}, []);

	useEffect(() => {
		if (errorMessages.length) {
			setRenderErrors([]);
			dispatch(errorActions.drop());
		}
	}, [email]);

	useEffect(() => {
		if (errorPage === "recover-pass") {
			if (errorMessages.includes("enter via your social account")) {
				setIsVisibleModal(true);
			}
			setRenderErrors(errorMessages);
		}
	}, [errorPage]);

	useEffect(() => {
		if (succes) {
			setIsSent(true);
		}
	}, [succes]);

	function onRecover() {
		dispatch(authActions.recover(email));
	}
	function goback() {
		navigate(-1);
	}

	function hideModal() {
		setIsVisibleModal(false);
		dispatch(errorActions.drop());
	}

	const back = [<Button key={"okAgreement"} text={"Back"} onClick={goback} type={"orange"} />];

	return (
		<>
			<div className="auth">
				<div className="auth__container auth__container_w500">
					<div className="auth__block">{/* <SelectLanguage /> */}</div>
					<div className="auth__line mb-30" />
					<div className="auth__block mb-30">
						<div className="auth__block-text mb-10">
							{isSent ? (
								<span className="auth__block-text_big">Please, check your inbox.</span>
							) : (
								<span className="auth__block-text_big">Password recovery</span>
							)}
						</div>
						<div className="auth__block-container">
							{isSent ? (
								<span className="auth__block-text auth__block-text_small ">
									Password recovery link was sent to your e-mail.
								</span>
							) : (
								<span className="auth__block-text auth__block-text_small ">
									You will receive an e-mail with instructions
								</span>
							)}
						</div>
					</div>
					{isSent ? (
						<Button text="BACK" className="mb-5" onClick={goback} />
					) : (
						<>
							<Input
								placeholder="Email"
								className="mb-40"
								outValue={email}
								setOutValue={setEmail}
								errorMessage={renderErrors}
							/>
							<Button
								text="RECOVER PASSWORD"
								className="mb-5"
								onClick={onRecover}
								isLoading={fetchAuth}
								disabled={!email}
							/>
							<div className="auth__block-container">
								<div className="auth__block-text auth__block-text_small ">I remember my password.</div>
								<Link to={"/auth/login"}>Log in</Link>
							</div>
						</>
					)}
				</div>
			</div>
			<Modal isVisible={isVisibleModal} buttons={back} onClose={hideModal}>
				<div className="auth__block-text_big recover-modal">Please, sign in using social network.</div>
			</Modal>
		</>
	);
};
